module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_england-1da54a2336834fe80200d2512f9a602a.png";